import ResumeComponent, { 
  ResumeText, 
  BulletPointSuggestion,
  Education,
  Experience,
  Project
} from './ResumeComponent';
import Resume from './Resume';
import Suggestions from './Suggestions';

export { 
  ResumeComponent,
  Resume,
  Suggestions
};

export type {
  ResumeText,
  BulletPointSuggestion,
  Education,
  Experience,
  Project
};

export default ResumeComponent; 